// extracted by mini-css-extract-plugin
module.exports = {"saveButton":"EditLabelPopUp_saveButton__3hwTR","colorsContainer":"EditLabelPopUp_colorsContainer__PN4uk"};